<template>
  <!-- -->
  <div class="system-setting">
    <separator-page>
      <template #category>
        <tree-dictionary :disabled="true" :filter="true" v-model="serviceList" :add-first-level-all="false" label-name="serviceName" @clickCategory="toShowSetting"/>
<!--        <div v-for="ser in serviceList" :class="currentService.id === ser.id?'service-list on': 'service-list'" @click="toShowSetting(ser)">{{ser.serviceName}}</div>-->
      </template>
      <template #default>
        <yq-empty description="当前服务没有配置项" v-if="currentService.settingList.length === 0"/>
        <div v-else class="setting-list">
          <div v-for="setting in currentService.settingList" :key="setting.id">
            <system-setting-components :setting="setting" @update="getList" :setting-list="allSettingList"/>
          </div>
        </div>
      </template>
    </separator-page>
  </div>
</template>

<script>
import systemSettingApi from "@/api/normal/sys/systemSettingApi";
import SystemSettingComponents from "./SystemSettingComponents";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
export default {
  name: "SS",
  components: {
    SeparatorPage, SystemSettingComponents, TreeDictionary
  },
  data() {
    return {
      serviceList: [],
      currentService: {
        settingList: [],
      },
      allSettingList: [],
    };
  },
  created() {
    // 商户开通了哪些服务
    systemSettingApi.queryAllService().then(list => {
      this.queryAllSettings(list);
    });
  },
  methods: {
    // 查询全部配置项
    queryAllSettings(list) {
      systemSettingApi.getSetting().then(settingList => {
        this.allSettingList = settingList;
        for (let i = 0; i < list.length; i++) {
          // 找到对应的配置
          let arr = [];
          for (let j = 0; j < settingList.length; j++) {
            if (settingList[j].serviceId === list[i].id) {
              arr.push(settingList[j]);
            }
          }
          list[i].settingList = arr;
          if (list[i].id === this.currentService.id) {
            this.currentService = list[i];
          }
        }
        this.serviceList = list;
      });
    },
    // 显示配置项
    toShowSetting(data) {
      // 处理showSetting嵌套
      let scArr = [];
      for (let i = 0; i < data.settingList.length; i++) {
        if(data.settingList[i].showSetting === 1){
          let newArr = [];
          for (let j = 0; j < data.settingList.length; j++) {
            if(data.settingList[j].settingCode.startsWith(data.settingList[i].settingCode) && data.settingList[j].settingCode !== data.settingList[i].settingCode){
              newArr.push(data.settingList[j]);
              scArr.push(j);
            }
          }
          data.settingList[i].showSettingList = newArr;
        }
      }
      // // 从后向前进行移除
      // for (let i = scArr.length - 1; i >= 0; i--) {
      //   data.settingList.splice(scArr[i], 1);
      // }

      this.currentService = {...data};
    },
    getList() {
      this.queryAllSettings(this.serviceList);
    }
  }
};
</script>

<style lang="scss" scoped>
.system-setting{
  height: 100%;
  box-sizing: border-box;
  padding-top: 10px;
  .setting-list{
    height: 100%;
    overflow: auto;
  }
}


</style>